module.exports=function(scope){ return `curl -X GET \
'https://your.internal.facetec.standard.server.instance.url/enrollment/INSERT_ENROLLMENT_IDENTIFIER_HERE' \
-H 'X-User-Agent: INSERT_X_USER_AGENT_VALUE_HERE'
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/bash/enrollment-get-facemap.bash.tpl